<template>
  <div class="flex flex-col justify-between items-start box-border w-full mt-4 p-3">
    <div class="flex gap-1 flex-col sm:flex-row flex-wrap items-start justify-start w-full">
      <FiltersComponent
        :allowFilter="{
          team: true,
          tag: true
        }"
        :max="employeeSatisfactionMaxSelection"
        :multiple="false"
        :modelValue="selections"
        @update:modelValue="saveSelection"
      />
    </div>
    <MessageBoxComponent is-warning :text="employeeSatisfactionWarning" />
    <div class="flex flex-col lg:flex-row relative w-full justify-start items-stretch box-border
      mt-5 text-left gap-3">
      <div class="w-full min-h-52 flex flex-col lg:w-3/5 card lg:min-h-96">
        <div class="flex w-full justify-between items-center">
          <h2>
            {{ $t('mngDashboardComponent.employeeSatisfactionOverTime') }}</h2>
          <Select v-model="employeeSelectFilter" :options="employeeSatisfactionPeriod"
              optionLabel="name" option-value="identifier" @change="applyEmployeeFilter"/>
        </div>
        <div class="relative w-full h-[400px] min-h-[400px]">
          <EmployeeSatisfactionChart ref="employeeSatisfaction" />
        </div>
      </div>
      <div class="w-full min-h-52 flex justify-start items-start flex-col box-border
        lg:w-2/5 gap-3">
        <div class="card w-full" v-show="showAverageChart">
          <div class="w-full flex justify-between items-center">
            <h2>
              {{ $t('mngDashboardComponent.avgEmployeeSatisfaction') }}</h2>
            <Select v-model="avgEmployeeSelectFilter" :options="employeeSatisfactionPeriod"
              optionLabel="name" option-value="identifier" @change="applyAvgEmployeeFilter"/>
          </div>
          <div class="relative h-44 w-full p-3 mt-3 box-border min-h-44" tabindex="0">
            <AvgEmployeeSatisfactionChart ref="avgEmployeeSatisfaction" />
          </div>
        </div>
        <div
          v-if="employeeSatisfactionText?.headline || employeeSatisfactionText?.text"
          class="text-white flex flex-col items-start w-full bg-[var(--color-orange)] rounded-xl
            box-border p-4">
          <div class="flex">
            <img src="@/assets/light.svg" alt="light" />
            <h2 v-html="employeeSatisfactionText?.headline" class="ml-3"></h2>
          </div>
          <p v-html="employeeSatisfactionText?.text" class="font-light text-sm"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmployeeSatisfactionChart from '@/components/Home/ManagementDashboard/SatisfactionReportComponent/EmployeeSatisfactionChartComponent.vue';
import AvgEmployeeSatisfactionChart from '@/components/Home/ManagementDashboard/SatisfactionReportComponent/AvgEmployeeSatisfactionChartComponent.vue';
import FiltersComponent from '@/components/Home/ManagementDashboard/common/FiltersComponent.vue';
import MessageBoxComponent from '@/components/Home/ManagementDashboard/common/MessageBoxComponent.vue';
import { Select } from 'primevue';

export default {
  name: 'SatisfactionReportComponent',
  data() {
    return {
      employeeSelectFilter: 'Last7Days',
      avgEmployeeSelectFilter: 'Last7Days',
      showAverageChart: true,
    };
  },
  components: {
    EmployeeSatisfactionChart,
    AvgEmployeeSatisfactionChart,
    FiltersComponent,
    MessageBoxComponent,
    Select,
  },
  computed: {
    selections: {
      get() {
        return this.$store.getters.getSelections;
      },
      set(value) {
        this.$store.commit('setSelections', value);
      },
    },
    employeeSatisfactionData() {
      return this.$store.getters.getMoodomat?.employeeSatisfactionData;
    },
    avgEmployeeSatisfactionData() {
      return this.$store.getters.getMoodomat?.avgEmployeeSatisfactionData;
    },
    employeeSatisfactionText() {
      return this.$store.getters.getMoodomat?.employeeSatisfactionText;
    },
    employeeSatisfactionPeriod() {
      return this.$store.getters.getMoodomat?.employeeSatisfactionPeriod;
    },
    employeeSatisfactionMaxSelection() {
      return this.$store.getters.getMoodomat?.maxSelection;
    },
    employeeSatisfactionWarning() {
      return this.$store.getters.getMoodomat?.warning;
    },
  },
  methods: {
    // --------- Main Function to call the api on every filters change ---------------- //
    async employeeOverAllFunction(isEmployee) {
      try {
        await this.$store.dispatch('fetchInitialEmployeeSatisfactionData', {
          selections: this.selections,
          employeePeriodType: this.employeeSelectFilter,
          avgEmployeePeriodType: this.avgEmployeeSelectFilter,
        });
        if (isEmployee === 'isEmployee') {
          this.$refs.employeeSatisfaction?.employeeSatisfactionLineChart(
            this.employeeSatisfactionData,
          );
        } else if (isEmployee === 'isAvgEmployee') {
          this.$refs.avgEmployeeSatisfaction?.avgEmployeeSatisfactionBarChart(
            this.avgEmployeeSatisfactionData,
          );
        } else {
          this.$refs.employeeSatisfaction?.employeeSatisfactionLineChart(
            this.employeeSatisfactionData,
          );
          this.$refs.avgEmployeeSatisfaction?.avgEmployeeSatisfactionBarChart(
            this.avgEmployeeSatisfactionData,
          );
        }
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check Console output!',
          detail: '',
          life: 3000,
        });
      }
    },
    // --------------- Filters---------------- //
    applyEmployeeFilter() {
      this.employeeOverAllFunction('isEmployee');
    },
    applyAvgEmployeeFilter() {
      this.employeeOverAllFunction('isAvgEmployee');
    },
    saveSelection(selection) {
      this.selections = selection;
    },
  },
  watch: {
    selections() {
      this.employeeOverAllFunction('');
    },
  },

  mounted() {
    this.employeeOverAllFunction('');
  },
};
</script>
